import { DhsPage } from 'components/pages';
import React from 'react';

export const Dhs = () => {
  return <DhsPage/>
};

